import { apiClient } from '@/api/client';
import { ENDPOINTS } from '@/api/endpoints';
import { UpdateCleanerDTO } from '@/api/requests/DTOS';

export const updateCleaner = async ({
  place,
  location,
  bio,
  price,
  slotsOperations,
}: UpdateCleanerDTO) => {
  await apiClient.patch(ENDPOINTS.CLEANERS, {
    place,
    location,
    bio,
    price,
    slots: slotsOperations,
  });
};
